import './vendor';
import './helpers';
import {vhFix} from './vendor/vh-fix';
import header from './components/header';
import search from './components/search';
import './components/slider';
import './components/social';
import './components/orderby';
import './components/tags';
import StickySidebar from './components/sticky-sidebar';
import './components/faq';
import dinamicVars from './components/dinamic-vars';
import lazyLoading from './modules/lazyLoading';
import scrollToAnchor from './modules/scrollToAnchor';

vhFix();
scrollToAnchor.init();

search.init();

dinamicVars.init();

header.init();
lazyLoading.init();


let sidebar = document.querySelector('.sidebar');

if( sidebar && typeof sidebar !== 'undefined' ) {
	new StickySidebar('.sidebar', {
		topSpacing: 40,
		bottomSpacing: 20,
		minWidth: 1200,
		containerSelector: '.content-row',
		innerWrapperSelector: '.sidebar__inner'
	});
}
else {
	console.log('Sidebar not exists');
}
